import React, {useState, useEffect} from 'react';
import {TextField, Button, Typography} from '@material-ui/core';
import {useSelector, useDispatch} from 'react-redux';
import allActions from '../actions'
import {saveToLocalStorage} from '../reducers/index';
import {useHistory} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import {SelectInput} from '../reusable/SelectInput'
import { loginRoleOptions } from '../utils/helper';
import user from '../services/user';

const useStyles = makeStyles((theme) => ({
    loginContainer: {
        width: '100%',
        height: 400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& h2':{
            fontSize:30,
            textAlign: 'center',
            color: '#007c9d',
            margin:'0 0 20px',
            fontWeight:'bold',
            textTransform:'uppercase'
        },
        '& button':{
            width: 300,
            padding:10,
            background: '#ed9523',
            color:'#fff',
            '&:hover':{
                background: '#ed9523',
            }
        }
    },
    formInput: {
        width: 300,
        margin: '0 0 20px',
        display:'block',
        '& >div':{
            width:'100%'
        }
    }
}));


const Login = () => {
    const classes = useStyles();
    const [loginForm, setLoginForm] = useState({
        userId: '',
        password: '',
        designation: ''
    })
    const currentUser = useSelector(state => state.currentUser)

    useEffect(() => {
        if (currentUser.loggedIn) {
            history.push('/dashboard')
        }
    }, [])

    const dispatch = useDispatch()
    const history = useHistory()


    const handleClick = async (event) => {
        event.preventDefault()
        if (!loginForm.designation) {
         alert('Please select Designation')
         return  
        }
        user.login(loginForm).then(({data})=> {
            if (data.token) {
                try {
                    dispatch(allActions.userActions.setUser(data))
                    saveToLocalStorage({
                        currentUser: {
                            user: data.token,
                            loggedIn: true,
                            designation: loginForm.designation
                        }
                    })
                    history.push('/dashboard')
                } catch {
                    
                }
            } else {
                alert(data.status)
            }
        }).catch((e)=> {
            console.error(e)
        })
    }

    return (
        <div className={classes.loginContainer}>
            <form onSubmit={handleClick}>
                <Typography component="h2">Login</Typography>
                <SelectInput  required error={!loginForm.designation ? true : false} label={'Select Designation'} name="designation" options={loginRoleOptions} onChange={(event) => setLoginForm({...loginForm, designation: event.target.value})}/>
                <TextField className={classes.formInput}
                           required
                           label="User Id"
                           variant="outlined"
                           onChange={(event) => setLoginForm({...loginForm, userId: event.target.value})}
                />
                <TextField className={classes.formInput}
                           type="password"
                           required
                           label="Password"
                           variant="outlined"
                           onChange={(event) => setLoginForm({...loginForm, password: event.target.value})}
                />
                <Button type="submit" variant="contained">
                    Submit
                </Button>
            </form>
        </div>
    );
}

const style = {
    margin: 15,
};
export default Login;